// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"animation-module--wrapper--3GUze"};